import { render, staticRenderFns } from "./TeacherRequestInventory.vue?vue&type=template&id=0bd0bcb0&lang=pug&"
import script from "./TeacherRequestInventory.vue?vue&type=script&lang=js&"
export * from "./TeacherRequestInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports